import { ITagging } from '../../models/common/metadata-tagging/tagging.model';
import { IContextInfo } from '../../models/master/context-info.model';
import { ISearchSort } from '../../models/plp/input/search-selector.model';
import { IPLPCategoryItem } from '../../models/plp/plp-category-item.model';
import { IPLPFacets } from '../../models/plp/plp-facets.model';
import { IPLPProduct, IPLPProducts } from '../../models/plp/plp-products.model';
import { IPLPSummary } from '../../models/plp/plp-summary.model';
import { IProductListPage } from '../../models/plp/product-list-page.model';
import { IBasketService } from '../../services/basket/basket-service';
import { IPartsListService } from '../../services/parts-list/parts-list-service';
import { IPLPService } from '../../services/plp/plp-service';
import { IFilterProductsResult, IPLPStockResult, IPreviewFilterResult, IUpdateProductsPage } from '../../services/plp/plp.dto';
import { IPricingService } from '../../services/pricing/pricing-service';
import { IProductService } from '../../services/product/product-service';
import { IPagination } from '../shared/page-controls/pagination.model';
import { OrderedFilter } from './filters/filters';

export type ProductListPageProps = {
  searchQuery?: string | null;
  data: IProductListPage;
  contextInfo: IContextInfo;
  plpService: IPLPService;
  pricingService: IPricingService;
  productService: IProductService;
  partsListService: IPartsListService;
  basketService: IBasketService;
  locationHash?: string;
};

export enum ProductListPageActionType {
  ToggleFilterModal = 'ToggleFilterModal',
  SetPartsListProps = 'SetPartsListProps',
  PreviewNewFilters = 'PreviewNewFilters',
  FilterProducts = 'FilterProducts',
  FilterProductsAndFacets = 'FilterProductsAndFacets',
  UpdateProducts = 'UpdateProducts',
  AddedToCart = 'AddedToCart',
  CloseConfirmationMessage = 'CloseConfirmationMessage',
  IsLoading = 'IsLoading',
  AddToPartList = 'AddToPartList',
  UpdateOnNavigation = 'UpdateOnNavigation',
  SetPLPStock = 'SetPLPStock',
  ToggleFilters = 'ToggleFilters',
  SetScrollPosition = 'SetScrollPosition',
}

export type Action =
  | { type: ProductListPageActionType.ToggleFilterModal }
  | {
      type: ProductListPageActionType.SetPartsListProps;
      showSelectedList?: boolean;
      product?: IPLPProduct;
      qty?: number;
    }
  | { type: ProductListPageActionType.PreviewNewFilters; newFilters: OrderedFilter[]; data: IPreviewFilterResult }
  | { type: ProductListPageActionType.FilterProducts; data: IFilterProductsResult }
  | {
      type: ProductListPageActionType.FilterProductsAndFacets;
      newFilters: OrderedFilter[];
      pagination: IPagination;
      sort?: ISearchSort;
      isOnPageLoad: boolean;
      data: IFilterProductsResult;
    }
  | {
      type: ProductListPageActionType.UpdateProducts;
      pagination: IPagination;
      sort?: ISearchSort;
      data: IUpdateProductsPage;
    }
  | { type: ProductListPageActionType.IsLoading; state: boolean }
  | { type: ProductListPageActionType.AddedToCart; stockCode: string; qty: number }
  | { type: ProductListPageActionType.CloseConfirmationMessage }
  | { type: ProductListPageActionType.AddToPartList; id?: number; name?: string; desc?: string }
  | { type: ProductListPageActionType.UpdateOnNavigation }
  | { type: ProductListPageActionType.SetPLPStock; data: IPLPStockResult }
  | { type: ProductListPageActionType.ToggleFilters }
  | { type: ProductListPageActionType.SetScrollPosition; x: number };

export type State = {
  pageUI: {
    hideFilters: boolean;
    xScroll: number;
  };
  isLoading: boolean;
  isFilterModalOpen: boolean;
  productsArea?: IPLPProducts | null;
  selectedNewFilters: OrderedFilter[];
  facetArea?: IPLPFacets | null;
  categoriesArea: IPLPCategoryItem[];
  summary?: IPLPSummary | null;
  preview: {
    summary?: IPLPSummary | null;
    facetArea?: IPLPFacets | null;
  };
  pagination: IPagination;
  sort?: ISearchSort;
  showAddedToCart: boolean;
  partLists: {
    listId?: number;
    showConfirmation: boolean;
    listCreated: boolean;
  };
  currentProduct?: { product?: IPLPProduct; qty: number };
  tagging: ITagging;
};
